module.exports = __webpack_public_path__ + "img/carousel-default.49d34ac1.png";